module.exports = __webpack_public_path__ + "public/img/ico-battery-status-problem.bcff2a58.svg";